<template>
  <div>
  <form novalidate>
    <div class="row  wizard-tab-container">
      <loader v-if="!isLoaded"></loader>

      <div class="col-12" v-if="isLoaded">
        <h1 class="page-title" v-if="protocol">{{'protocol.protocol' | trans}}: {{protocol.title}}</h1>
        <h2 class="second-title" v-if="protocol && protocol.teachingMethod.id !== 5 && protocol.teachingMethod.id !== 6 && protocol.teachingMethod.id !== 9">{{'protocol.choose_stage' | trans}}</h2>
        <h2 class="second-title" v-if="protocol && (protocol.teachingMethod.id === 5 || protocol.teachingMethod.id === 6)">{{'protocol.chooseEnvironment' | trans}}</h2>
        <h2 class="second-title" v-if="protocol && (protocol.teachingMethod.id === 9)">{{'protocol.chooseLevel' | trans}}</h2>
        
        <div class="row" v-if="protocolsData && stagesList.length">

          <div class="mt-3 col-lg-3 col-md-4 link-stage"  v-for="stage in stagesList"
               v-if="!stage.isClosed">
            <router-link  v-if="protocol && protocol.teachingMethod.id !== 4 && protocol.teachingMethod.id !== 1  && protocol && protocol.teachingMethod.id !== 2 && protocol.teachingMethod.id !== 9 && protocol.teachingMethod.id !== 10"
                class="link-stage__button"
                :to="{ name: protocol.teachingMethod.id === 5 ? 'chain-stage-current' : protocol.teachingMethod.id === 6 ? 'shaping-stage-current' : 'mand-stage-current', params: {protocolData: protocolsData, stageId:stage.id}}">
              <h4 class="link-stage__title">{{stage.description}}</h4>
            </router-link>
            <router-link  v-if="protocol && protocol.teachingMethod.id === 4"
              class="link-stage__button"
              :to="{ name: 'choose-usd', params: {protocolData: protocolsData, stageId:stage.id}}">
              <h4 class="link-stage__title">{{stage.description}}</h4>
            </router-link>
            <router-link  v-if="protocol && protocol.teachingMethod.id === 1"
                          class="link-stage__button"
                          :to="{ name: 'choose-stage', params: {protocolData: protocolsData, stageId:stage.id}}">
              <h4 class="link-stage__title">{{stage.description}}</h4>
            </router-link>

            <router-link class="link-stage__button" v-if="protocol.teachingMethod.id === 2"
                         :to="{ name: 'current-stage', params: { clientId: clientId, protocolData: protocolsData, stageId:stage.id}}">
              <h4 class="link-stage__title">{{stage.description}}</h4>
            </router-link>

            <router-link class="link-stage__button" v-if="protocol.teachingMethod.id === 9 && stage.isAvailable && !stage.isDisabled"
                         :to="{ name: 'pecs-with-discrimination-stage', params: { clientId: clientId, protocolData: protocolsData, stageId:stage.id}}">
              <h4 class="link-stage__title">{{stage.description}}</h4>
            </router-link>

            <span class="link-stage__button disabled" v-if="protocol.teachingMethod.id === 9 && !stage.isAvailable && !stage.isDisabled">
              <h4 class="link-stage__title">{{stage.description}}</h4>
            </span>

            <router-link class="link-stage__button " v-if="protocol.teachingMethod.id === 10"
                         :to="{ name: 'pecs-with-items-stage', params: { clientId: clientId, protocolData: protocolsData, stageId:stage.id}}">
              <h4 class="link-stage__title">{{stage.description}}</h4>
            </router-link>

          </div>

        </div>

        <div class="col-12" v-if="!stagesList.length">

          {{'protocol.withoutProperties' | trans}}

        </div>
      </div>
    </div>

  </form>

  </div>

</template>

<script>
  import axios from 'axios';
  import {mapGetters, mapState, mapActions} from 'vuex';
  import filter from 'lodash/filter';
  import Loader from '../../loader/components/Loader';
  import Instruction from '@/common/instruction/components/InstructionView';
  import lang from '../../../lang/translator';
  import {PROTOCOL_STATUSES} from '../../protocols/constants.js';


  export default {
    components: {Instruction, Loader},
    name: 'ReactionStageList',
    props: {
      'name': null,
      'protocolData': null,
      'clientData': null,
      'protocolId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        apiUrl: '/protocols/assigned/',
        apiClientUrl: '/users/clients/',
        protocol: null,
        supportCount: null,
        client: {},
        assignedProtocolId: null,
        loaded: false,
        protocolsData: this.protocolVuexData,
        isLoaded: false,
        execution: '',
        stagesList: [],
        title: lang.get('protocol.confirm_close'),
      };
    },
    computed: {
      ...mapState([
        'route',
      ]),
      ...mapGetters('auth', [
        'isClient',
        'isBCBA',
        'isCurator',
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapState('protocol', [
        'protocolVuexData',
      ]),

    },
    created() {
      if (this.isClient){
        this.$router.push({name: 'protocol-item', params: {clientId: this.clientId, protocolData:this.protocolVuexData}});
      } else{
        this.fetchProtocol();
      }
    },

    methods: {

      ...mapActions('protocol', [
        'setProtocol',
      ]),

      detectProtocol: async function() {
        let response = await axios.get(this.apiUrl + this.protocolId + '/teaching-method' );
        return response.data.data.id;
      },

      fetchProtocol: async function() {
        this.isLoaded = false;
        if (!this.protocolVuexData){
          this.fetchProtocolData();
        } else{
          this.protocolsData = this.protocolVuexData;
          this.assignedProtocolId = this.protocolVuexData.assigneeId;
          this.client = this.clientData;
          this.initProtocolData();
        }
      },

      fetchProtocolData: async function() {
        try {
          let teachingMethodId = await this.detectProtocol();
          let urlMap = {
            1: 'dtt',
            2: 'simple',
            3: 'mand',
            4: 'vcd',
            5: 'chain',
            6: 'shaping',
            9: 'pecs-with-discrimination'
          };
          let apiUrl =  this.apiUrl + urlMap[teachingMethodId] + '/' + this.protocolId + '/info';

          let response = await axios.get(apiUrl);
          this.protocolsData = response.data.data;
          this.setProtocol(this.protocolsData);
          this.assignedProtocolId = this.protocolsData.assigneeId;
          if (!this.client){
            await this.getClient(this.clientId)
          }
          if(response){
            this.initProtocolData();
          }
        } catch (error) {
          console.dir(error)
          this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
        }
      },

      initProtocolData: function() {
        this.protocol = this.protocolsData.protocol;
        let status = this.protocolsData && this.protocolsData.status && this.protocolsData.status.id ? this.protocolsData.status.id : null;
        this.stagesList = this.protocol.stages;
        let stageActiveList = this.protocol.stages.length ? filter(this.protocol.stages, ['isClosed', false]) : [];
        if((!stageActiveList.length || status === PROTOCOL_STATUSES.INDIVIDUALIZATION) && this.protocol.teachingMethod.id !== 9){
          this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
        }

        this.isLoaded = true;
      },

      getClient: async function(clientId) {
        try {
          let response = await axios.get(this.apiClientUrl + clientId);
          this.client = response.data.data;
          return response;
        } catch (error) {
          console.dir(error)
        } finally {
          this.loaded = true
        }
      },
      backToPreviousPage() {
        if (this.clientId || this.assignedProtocolId) {
          this.$router.push({name: 'client-edit', params: { clientId: this.clientId || this.assignedProtocolId }});
        }
        else {
          this.$router.push({name: 'protocols'});
        }
      },


    }

  }
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/ReactionStagesList.vue